import React, {useEffect, useState} from "react";
import zoomImg from "../../../../assets/icons/imgBtn.svg";
import BlogImagePopper from "./BlogImageLarge";
import image2 from "../../../../assets/images/Blog38/image2 AAII bears and undecided low.png";
import image3 from "../../../../assets/images/Blog38/image3 P_C ratios.png";
import image4 from "../../../../assets/images/Blog38/image4 gamma flip flop flip.png";
import image5 from "../../../../assets/images/Blog38/image5 volatility complex.png";
import image6 from "../../../../assets/images/Blog38/image6 SPX realised vol spike.png";
import image7 from "../../../../assets/images/Blog38/image7 SPX technical fib+vix bounce.png";
import image9 from "../../../../assets/images/Blog38/image9 SPX expanded flat.png";
import image10 from "../../../../assets/images/Blog38/image10 leveraged retail all in.png";
import image11 from "../../../../assets/images/Blog38/image11.png";
import image13 from "../../../../assets/images/Blog38/image13 SPX after SeP+ and Q3 above 100dma.png";
import image16 from "../../../../assets/images/Blog38/image16 no Trump peace prize.png";
import image17 from "../../../../assets/images/Blog38/image17 US rescues.png";
import image18 from "../../../../assets/images/Blog38/image18 US bailout mechanism for Argentina.png";
import image19 from "../../../../assets/images/Blog38/image19 military next up for no pay.png";
import image20 from "../../../../assets/images/Blog38/image20 $ flows into Gold.png";
import image23 from "../../../../assets/images/Blog38/image23 UJ rallying_.png";
import image24 from "../../../../assets/images/Blog38/image24 CPI release coming.png";
import image34 from "../../../../assets/images/Blog38/image34 liquidity tight.png";
import image46 from "../../../../assets/images/Blog38/image46 EW131025.png";
import image52 from "../../../../assets/images/Blog38/image52 GOLD 8th oct 4k.png";
import image54 from "../../../../assets/images/Blog38/image54 UJ 8th Oct.png";
import image56 from "../../../../assets/images/Blog38/image56 VXN diverges with NAS100.png";

const Blog38 = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const handleRedirect = (url) => {
    window.open(url, "_blank");
  };
  const handleLargeImg = (img) => {
    setSelectedImage(img);
  };
  return (
    <div className="MainNewBlog">
      <div className="blogHeader">
        <h2 className="headerBoldText mainHeader">Weekly Market Outlook – October 13th, 2025</h2>
      </div>
      <div className="blogContentnew">
        <p className="highlightedText">Volatility Awakens, Tariff Shocks, and the Return of “Voltober”</p>
        <p>
          After months of low-volatility drift, markets finally got their reality check. Positioning had become stretched, sentiment complacent, and the VIX complacently low. It only took a spark —
          Trump’s latest tariff salvo against China — to send volatility ripping higher and equities tumbling into a long-overdue correction.
        </p>
        <p>
          Friday’s close on the lows was ominous, but as any trader knows, Fridays rarely mark the bottom. The futures bounce that followed looks more like a reflex than a reversal — we’ll need a
          classic three-wave pattern and a solid retest of late-session lows to confirm that the impulsive uptrend is still intact.
        </p>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper flexDiv">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Market Overview: When Calm Turns to Chaos</p>
              <p>
                Everything was ticking along in “low-vol land” — until it wasn’t. The U.S. equity rally, driven by concentrated AI mania and short-volatility flows, finally met resistance.
                Fundamentals hadn’t broken, but sentiment clearly had.
              </p>
              <p>
                Trump’s renewed spat with China, suggesting Xi “won’t want to put China into depression,” became the catalyst for what the charts had already warned: divergence, stretched sequences,
                and non-confirmations at all-time highs.
              </p>
              <p>The AAII sentiment data confirmed the froth — high bulls, few bears, and almost no undecided participants — a classic setup for a sentiment snapback.</p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image2}
                    alt="AAII bears and undecided low"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image2)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                Even the put-call ratios reflected complacency: a 0.81 equity P/C and only moderate index hedging via a 1.2 index ratio. But the market had quietly flipped to a negative gamma regime
                into Friday’s close, setting up a self-reinforcing sell dynamic that reversed only after Monday’s technical rebound.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image4}
                    alt=" Gamma flip flop flip"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image4)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image3}
                    alt="P/C ratios"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image3)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper flexDiv ">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Macro & Policy Watch: Fragile Fundamentals and Political Fractures</p>
              <p>
                The macro backdrop remains fragile but not broken. Fundamentals suggested a seasonal pullback was overdue. The U.S. government shutdown continues to cast uncertainty across data
                releases — even as the Bureau of Labour Statistics recalled key workers to deliver the CPI print due October 24th, which remains critical for Social Security adjustments and Fed
                calibration.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image24}
                    alt="CPI release coming"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image24)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                In Europe, data disappointed again — Germany’s numbers remain weak, while ECB officials turned hawkish amid structural stagnation and political fractures in France. The IMF and World
                Bank meetings this week may set the tone for global coordination — or confirm the lack of it.
              </p>
              <div className="contentDiv listOfRecap">
                <p>Meanwhile, geopolitical noise intensified:</p>
                <ul className="pointersSection">
                  <li className="themesPointer">
                    <p>Trump landed in Israel to bask in the peace-deal spotlight (without the Nobel).</p>
                  </li>
                  <div
                    className="imageWrapperCont"
                    // style={{justifyContent: "flex-start"}}
                  >
                    <div className="relatedImg">
                      <img
                        src={image16}
                        alt="No Trump peace prize"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image16)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt=""
                          />
                        </button>
                      </div>
                    </div>
                  </div>

                  <li className="themesPointer">
                    <p>France continues to simmer politically, Japan’s coalition collapsed, and Argentina needed yet another U.S. Treasury bailout.</p>
                  </li>
                  <div
                    className="imageWrapperCont"
                    // style={{justifyContent: "flex-start"}}
                  >
                    <div className="relatedImg">
                      <img
                        src={image18}
                        alt="US bailout mechanism for Argentina"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image18)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt=""
                          />
                        </button>
                      </div>
                    </div>
                  </div>

                  <li className="themesPointer">
                    <p>The U.S. military payroll risk due to the shutdown looms large.</p>
                  </li>
                  <div
                    className="imageWrapperCont"
                    // style={{justifyContent: "flex-start"}}
                  >
                    <div className="relatedImg">
                      <img
                        src={image19}
                        alt="Military next up for no pay"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image19)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt=""
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </ul>

                <div className="imageWrapperCont">
                  <div className="relatedImg">
                    <img
                      src={image17}
                      alt="U.S. rescues"
                    />
                    <div
                      className="zoomBtn"
                      onClick={() => handleLargeImg(image17)}
                    >
                      <button>
                        <img
                          src={zoomImg}
                          alt=""
                        />
                      </button>
                    </div>
                  </div>
                </div>

                <p>
                  Monetary policy chatter adds complexity: the Fed remains open to defensive cuts but faces rising inflation stickiness. ECB leans hawkish, the BoE is split, and Japan’s transition of
                  leadership could redefine its tightening trajectory. Yen stability remains a key macro pivot.
                </p>
              </div>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image23}
                    alt="UJ rallying?"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image23)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper flexDiv">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Technical & Sentiment Breakdown: The Volatility Reprice Takes Hold</p>
              <p>
                The technicals screamed pullback long before headlines hit. SPX futures bounced 1.5%, touching resistance near 6650 — just below the 61.8% Fib retracement — but failed to sustain it.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image6}
                    alt="SPX realised vol spike"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image6)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image7}
                    alt="SPX technical fib + VIX bounce"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image7)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                Negative gamma dynamics faded as call-heavy positioning around 6500 cushioned downside volatility. Still, the shift from positive to negative gamma zones is a trader’s warning:
                liquidity providers are no longer stabilisers.
              </p>
              <p>
                The VIX’s move into the mid-20s and the reversal of its 20-day moving average is crucial. We now have “Voltober” in full swing — both implied and realised vol are rising in tandem for
                the first time since the Japanese carry-trade unwind earlier this year.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image5}
                    alt="Volatility complex"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image5)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image56}
                    alt="VXN diverges with NAS100"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image56)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>The divergence between NAS100 and its volatility index (VXN) — highlighted last week — played out precisely. That’s textbook sentiment exhaustion.</p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image11}
                    alt="NAS100 after ATH and -3% close"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image11)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>Volume data also confirmed distribution: only ~50% of SPX components remain above their 200DMA, and new highs-minus-lows turned decisively negative over shorter windows.</p>

              <div className="relatedImg">
                <img
                  src={image13}
                  alt="SPX after Sep+ and Q3 above 100dma"
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(image13)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
              <p>
                Still, the broader uptrend remains technically valid if Friday’s low holds. An expanded flat correction (wave 4) scenario could mean Friday marked a mid-structure low — not an end.
              </p>

              <div className="relatedImg">
                <img
                  src={image9}
                  alt="SPX expanded flat"
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(image9)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
              <p>Retail leveraged exposure is at extremes again — margin longs, leveraged ETFs, and call buying are crowding the tape.</p>
              <div className="relatedImg">
                <img
                  src={image10}
                  alt="Leveraged retail all in"
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(image10)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Last Week’s Recap – Voltober Begins</p>
              <p className="highlightedText">
                The long-awaited correction finally arrived as Trump’s renewed tariff rhetoric against China triggered a surge in volatility and flushed out crowded risk positions.
              </p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    U.S. indices snapped their low-volatility drift as <span className="highlightedText"> VIX and VXN </span> spiked into the 20s, ending months of calm. The selloff was broad-based —
                    led by technology and momentum names — but disciplined, with no signs of panic liquidation.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    European data disappointed again, reinforcing the region’s macro underperformance, while Japan’s political uncertainty added to global unease. Despite the turbulence,
                    <span className="highlightedText"> earnings momentum remained </span> resilient, and risk flows rotated into commodities, particularly{" "}
                    <span className="highlightedText"> gold and silver </span>, which both broke fresh highs amid renewed safe-haven demand.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    Asia lagged, weighed down by China tech and export concerns, while retail sentiment flipped sharply from euphoria to caution. What began as a complacent “Uptober” turned into
                    <span className="highlightedText"> Voltober </span> — a live test of conviction and positioning discipline.
                  </p>
                </li>
              </ul>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image6}
                    alt="SPX realised vol spike"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image6)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image11}
                    alt="NAS100 after ATH and -3% close"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image11)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image20}
                    alt="$ flows into Gold"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image20)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">The Week Ahead – Data Returns, Volatility Remains</p>
              <p>With the U.S. still partially shut down, traders will key in on global data, earnings kick-offs, and high-profile Fed commentary ahead of the pre-meeting blackout.</p>
              <p className="highlightedText">Monday, Oct 13, 2025</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>U.S. & Canada Holidays (Columbus Day, Thanksgiving)</p>
                </li>
                <li className="themesPointer">
                  <p>IMF Meetings continue</p>
                </li>
                <li className="themesPointer">
                  <p>Watch early futures positioning and volatility flows</p>
                </li>
              </ul>

              <p className="highlightedText">Tuesday, Oct 14, 2025</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>U.K. Employment & Wages</p>
                </li>
                <li className="themesPointer">
                  <p>Germany ZEW Economic Sentiment</p>
                </li>
                <li className="themesPointer">
                  <p>U.S. NFIB Small Business Optimism</p>
                </li>
                <li className="themesPointer">
                  <p>Major Bank Earnings: JPM, Citi, BlackRock, GS</p>
                </li>
              </ul>

              <p className="highlightedText">Wednesday, Oct 15, 2025</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>China CPI/PPI</p>
                </li>

                <li className="themesPointer">
                  <p>U.S. CPI (Key: BLS recalls staff for release)</p>
                </li>
                <li className="themesPointer">
                  <p>Eurozone Industrial Production</p>
                </li>
                <li className="themesPointer">
                  <p>Fed Beige Book</p>
                </li>
              </ul>

              <p className="highlightedText">Thursday, Oct 16, 2025</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>U.S. Retail Sales & PPI</p>
                </li>

                <li className="themesPointer">
                  <p>Philly Fed Manufacturing Index</p>
                </li>
                <li className="themesPointer">
                  <p>ECB’s Lagarde & Fed Waller speeches</p>
                </li>
              </ul>

              <p className="highlightedText">Friday, Oct 17, 2025</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>Eurozone Final CPI</p>
                </li>

                <li className="themesPointer">
                  <p>U.S. Housing Starts & Industrial Production</p>
                </li>
                <li className="themesPointer">
                  <p>IMF Annual Meetings (Final Day)</p>
                </li>
              </ul>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image46}
                    alt="EW131025.png"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image46)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>Buyback blackouts peak mid-month, and volatility tends to seasonally rise in October — pullbacks here could be tactical entry zones for year-end positioning.</p>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Alpha Takeaway: Voltober Has Arrived — Risk-On, But Fragile</p>
              <p>
                Markets remain broadly risk-on, but the tone has turned increasingly fragile. AI exuberance, heavy positioning, and stretched liquidity have kept the melt-up alive, yet cracks beneath
                the surface are widening. The sharp rise in volatility marked a necessary reset — not the end of the trend.
              </p>

              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Gold</span> is pushing into record territory, its rate of change approaching historical extremes — a potential exhaustion zone even as inflows
                    accelerate. The ongoing shift toward real assets underscores rising distrust in policy stability and currency debasement themes.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Crypto </span> is enjoying its own “Voltober” resurgence, with <span className="highlightedText"> Bitcoin confirming its wave-4 low </span> and
                    institutional participation expanding. The pattern mirrors prior mid-cycle rotations — resilient momentum built on liquidity reallocation rather than retail speculation.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Equities </span> remain structurally supported by liquidity, earnings, and dovish bias, but leverage and sentiment are overheated. The base case
                    remains a <span className="highlightedText"> shallow 5–7% correction </span> before the uptrend resumes into year-end as volatility normalises and breadth stabilises.
                  </p>
                </li>
              </ul>
              <p>“This isn’t a bear market — it’s a volatility reprice. Still in uptrend, still risk-on. Just smaller stakes both ways.”</p>

              <p className="highlightedText">Our stance:</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Equities: </span>Stay long but trim leverage; buy pullbacks near key support zones.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Gold & Silver: </span>Momentum strong but extended — partial profit-taking prudent.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Crypto: </span>Constructive structure; momentum can extend further.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Macro Focus:</span> Fed data blackout implications, IMF meeting tone, and OPEC’s volume-first policy stance.
                  </p>
                </li>
              </ul>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image52}
                    alt="GOLD 8th Oct 4k"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image52)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image54}
                    alt="UJ 8th Oct"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image54)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image34}
                    alt="Liquidity tight"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image34)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />

        <div className="button_wrapper">
          <button
            className="gradientButton_small "
            onClick={() => {
              handleRedirect("https://docs.google.com/document/d/1Bb_LB6NBcHsAO7gVKoVNfNN4acs3PJb9z88ljDmSG-g/edit?usp=sharing");
            }}
          >
            Read In-Depth Market Outlook
          </button>
        </div>
      </div>
      {selectedImage && (
        <BlogImagePopper
          image={selectedImage}
          onClose={() => handleLargeImg(null)}
        />
      )}
    </div>
  );
};

export default Blog38;
